import React from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash/isNil';
import MLIcon from '../../../../../../../components/MLIcon/MLIcon';

import s from './SRLOffOnTrack.module.css';

const OffOnTrack = ({ onTrack, offTrack }) => {
  let onTrackContent = null;
  let offTrackContent = null;

  if (!isNil(offTrack)) {
    offTrackContent = (
      <div>
        <div className={s.iconValueContainer}>
          <MLIcon
            className={s.offIcon}
            type="chevron_double_down"
            role="presentation"
            width="20"
            height="20"
          />
          <span className={s.value}> {offTrack} </span>
        </div>
        <div className={s.label}>now off track</div>
      </div>
    );
  }

  if (!isNil(onTrack)) {
    onTrackContent = (
      <div>
        <div className={s.iconValueContainer}>
          <MLIcon
            className={s.onIcon}
            type="chevron_double_up"
            role="presentation"
            width="20"
            height="20"
          />
          <span className={s.value}> {onTrack} </span>
        </div>
        <div className={s.label}>now on track</div>
      </div>
    );
  }

  if (!onTrackContent && !offTrackContent) {
    return (
      <div className={s.emptyContainer}>
        <div className={s.title}>no change</div>
        <div>since previous survey</div>
      </div>
    );
  }

  return (
    <div className={onTrackContent && offTrackContent ? s.content : s.singleContent}>
      {offTrackContent}
      {onTrackContent}
    </div>
  );
};

OffOnTrack.propTypes = {
  offTrack: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onTrack: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
};

export default OffOnTrack;

export const reduceOnOffTrack = (answerChangeData) => {
  // These are the possible answers for "Are you currently on track to accomplish your goals for this class?"
  const OFF_TRACK = 'No';
  const ON_TRACK = 'Yes';

  return answerChangeData.reduce((acc, answerChange) => {
    const currentAnswer = answerChange?.current_answer;

    if (currentAnswer === OFF_TRACK) {
      // There could be a case where the previous answer was null
      // (because the student didn't do the previous survey)
      // so we combine the null -> OffTrack with the onTrack -> offTrack
      acc.offTrack = !acc.offTrack ? answerChange?.count : acc.offTrack + answerChange?.count;
    } else if (currentAnswer === ON_TRACK) {
      acc.onTrack = !acc.onTrack ? answerChange?.count : acc.onTrack - answerChange?.count;
    }

    return acc;
  }, {});
};

